import Member from "../../layouts/Member/Member";


const MemberPage = () => {
  return (
    <Member />
  );
}

export default MemberPage;